import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;


if (!isMobileFirstLoad) {
    const tlBlockInfoCards = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-block-infos-cards'
        }
    });

    const titleBlockInfoCards = new SplitText(
        '.mksun-block-infos-cards .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const linesBlockInfoCards = new SplitText(
        '.mksun-block-infos-cards .timeline-text-reveal--lines',
        {
            type: 'lines'
        }
    );

    tlBlockInfoCards.from(
        titleBlockInfoCards.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlBlockInfoCards.from(
        linesBlockInfoCards.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    const cardsBlockInfoCards = document.querySelectorAll(
        '.mksun-block-infos-cards .mksun-block-infos-cards__content__card'
    );

    tlBlockInfoCards.from(
        cardsBlockInfoCards,
        {
            y: 32,
            opacity: 0,
            stagger: 0.25
        },
        '<'
    );
}

/*
  const tlBlockInfo = gsap.timeline({
      scrollTrigger: {
          trigger: '.mksun-block-infos',
          start: "top+=25% center",

      }
  });

  const titleBlockInfo = new SplitText('.mksun-block-infos .timeline-text-reveal:not(.timeline-text-reveal--lines)', {
      types: 'lines,words,chars',
  })

  const linesBlockInfo = new SplitText('.mksun-block-infos .timeline-text-reveal--lines', {
      types: 'lines,words,chars',
  })

  tlBlockInfo.from(titleBlockInfo.words, {
      y: '100%', opacity: 0, duration: 0.5, ease: 'power1.out', stagger: 0.1,
  })

  tlBlockInfo.from(linesBlockInfo.lines, {
      y: '100%', opacity: 0, duration: 0.5, ease: 'power1.out', stagger: 0.1,
  })

  const ctnCardsBlockInfo = document.querySelectorAll('.mksun-block-infos__right-col')
  const cardsBlockInfo = document.querySelectorAll('.mksun-block-infos .mksun-card-info')

  gsap.set(ctnCardsBlockInfo, {height: cardsBlockInfo[0].offsetHeight})


  const firstCardInfo = document.querySelector(".mksun-card-info");
  const ctnCardsInfo = document.querySelector(".mksun-card-info-ctn");

// i need to get the distance between the first card and the bottom of the screen
  const distanceToBottom = (window.innerHeight - cardsBlockInfo[0].offsetHeight) / 2 + cardsBlockInfo[0].offsetHeight;

// set the gap between cards to the distance to bottom
  cardsBlockInfo.forEach((card, index) => {
      if (index !== 0) {
          gsap.set(card, {
              top: distanceToBottom,
          })
      }
  })

  const callBackAnimation = (self) => {
      const gapScroll = 1 / cardsBlockInfo.length
      const currentSection = Math.floor(self.progress / gapScroll)

      // I need to get the progress from 0 to 1 of the current section
      // For exemple here we got 3 cards, the first section is between 0 and 0.33, the second section is between 0.33 and 0.66, the third section is between 0.66 and 1
      // I need to get the progress between 0 and 1 of the current section like the first one 0 and 0.33

      const progressSection = (self.progress - (currentSection * gapScroll)) / gapScroll

      cardsBlockInfo.forEach((cardItem, index) => {
          if (index <= currentSection) {
              gsap.to(cardItem, {top: 0, duration: 0.5})
          } else if (index === currentSection + 1) {
              gsap.to(cardItem, {top: distanceToBottom * (1 - progressSection), duration: 0.5})
          }
      })
  }


  const tlScrollBlockInfo = gsap.timeline({
      scrollTrigger: {
          trigger: '.mksun-block-infos',

          start: 'center center',
          end: `${cardsBlockInfo.length * 100}% center`,
          pin: true,
          pinSpacing: true,
          //markers: true,
          onEnter: (self) => {
              callBackAnimation(self)
          },
          onUpdate: (self) => {
              callBackAnimation(self)
          }
      }
  });
*/});